// extracted by mini-css-extract-plugin
export default {"loadingIcon":"loadIcon__loadingIcon__hPgME","loading":"loadIcon__loading__jctlP"};